// extracted by mini-css-extract-plugin
export default {"barLabel":"task-list_barLabel__HBDPk","barLabelOutside":"task-list_barLabelOutside__abl1Z"};